import * as lodash from 'lodash/fp';
import { defineModule, localActionContext } from "direct-vuex"

import * as ServicesSold from "@/lib/Util/Types/Reports/ServicesSold";
import * as Filter from "./Filter"

import * as REST from '@/lib/Util/REST'
import { RootState } from '@/store/Shared'

const state = {
    value: [] as ServicesSold.T[],
    filter: Filter.getEmpty(),
    message: REST.getEmpty(),
}

const mutations = {
    updateValue(state: State, model: ServicesSold.T[] | null) {
        const values = model ?? []
        state.value = values;
    },
    updateMsg(state: State, v: REST.RestMessage) {
        state.message = v
    },
    updateFilter(state: State, v: Filter.T) {
        state.filter = v
    }
}

const getters = {}

export function migrate(token?: string) {
    const req = {
        token: token ?? "NO TOKEN",
        url: "/reports/services_sold_migrate",
        payload: {},
        transformer: function (v: any) { console.log("TRANSFORM:", v); return null }
    };
    return REST.GET(state.message, req);
}


export function load(filter: Filter.Query, token: string, msg?: REST.RestMessage) {
    const req = {
        token: token,
        url: "/reports/services_sold",
        payload: filter,
        transformer: ServicesSold.tryParseList
    };
    return REST.GET(msg ?? REST.getEmpty(), req);
}

const actions = {
    async LOAD(context: any, filter: Filter.Query) {
        /* eslint-disable @typescript-eslint/no-use-before-define */
        const { commit, state } = actionCtx(context)
        const rootState = context.rootState as RootState
        try {
            const loading_msg = {
                ...state.message,
                loading: true
            }
            commit.updateMsg(loading_msg)
            commit.updateValue([])
            const req = {
                token: rootState.authentication?.token ?? "NO TOKEN",
                url: "/reports/services_sold",
                payload: filter,
                transformer: ServicesSold.tryParseList
            };
            const result = await REST.GET(state.message, req);
            const msg = {
                ...lodash.cloneDeep(result.msg),
                text: "Successfully loaded services received list",
                timeout: 5000
            }
            commit.updateValue(result.value)
            commit.updateMsg(msg)
        }
        catch (ex) {
            const msg = {
                ...lodash.cloneDeep(state.message),
                text: JSON.stringify(ex)
            }
            commit.updateMsg(msg)
        }
    }
}

export const internal = {
    namespaced: true as const,
    state,
    mutations,
    getters,
    actions
}

export type Mutations = typeof mutations
export type State = typeof state
export type Getters = typeof getters
export type Actions = typeof actions

export const module = defineModule(internal)
export type Module = typeof module
export default module

const actionCtx = (context: any) => localActionContext(context, module)
